// extracted by mini-css-extract-plugin
export default {"icon__btn":"IconButtons_icon__btn__o2Q6V"};